import { getCurriculum } from 'a/wordSlide/content/curriculum/curriculum';
import { getSyllable } from 'a/wordSlide/lib/utilityFunctions';
import { ITEM_TYPE } from 'a/wordSlide/data/constants';

export const getCurriculumLevels = () => getCurriculum().levels;

export const getOnboardingLevels = () => getCurriculum().onboardings;

export const getCurriculumLevelsCount = () => getCurriculumLevels().length;

export const getCurriculumLevel = id => getCurriculumLevels().find(level => level.levelId === id);

export const getCurriculumQuestion = (levelId, questionIndex) => {
  const level = getCurriculumLevel(levelId);
  if (level && questionIndex < (level.standardItems || []).length) {
    return level.standardItems[questionIndex];
  }
  return undefined;
};

export const getCurriculumQuestionCount = id => getCurriculumLevel(id).standardItems.length;

export const getPracticeItems = round => getCurriculumLevel(round.levelId).practiceItems;

export const getCurrentPracticeItem = round => getPracticeItems(round)[round.practiceIndex];

export const getCurrentPracticeTargetAudio = (round, letter) => {
  const foundItem = getCurrentPracticeItem(round).find(item => item.isCorrect);
  return getSyllable(foundItem.word, letter);
};

export const getCurrentPracticeTargetWord = round =>
  getCurrentPracticeItem(round).find(item => item.isCorrect).word;

export const hasNextPracticeItem = round =>
  round.practiceIndex < getPracticeItems(round).length - 1;

export const getOnboardingData = (type) => {
  switch (type) {
    case 'silentE':
      return getOnboardingLevels().find(level => level.type === ITEM_TYPE.SILENT_E);

    case 'rlControlled':
      return getOnboardingLevels().find(level => level.type === ITEM_TYPE.R_CONTROLLED);

    case 'inflectedEnding':
      return getOnboardingLevels().find(level => level.type === ITEM_TYPE.INFLECTED_ENDING);

    default:
      return getOnboardingLevels()[0];
  }
};
